export default function AjaxsScript() {
  jQuery(document).ready(function ($) {
    const $paginationContainer = $('#ajax-pagination-container')
    const $postContainer = $('#ajax-post-container')

    let currentFilterId = $paginationContainer.data('cat-id')
    let currentFilterType = 'cat'

    function loadPosts(
      paged,
      filterId = currentFilterId,
      filterType = currentFilterType
    ) {
      $postContainer.css('opacity', '0.5')
      $paginationContainer.css('pointer-events', 'none')

      let postData = {
        action: 'load_next_post',
        paged: paged,
        perpage: $paginationContainer.data('perpage'),
        cat_id: 0,
        tag_id: 0
      }

      if (filterType === 'cat' && filterId > 0) {
        postData.cat_id = filterId
      } else if (filterType === 'tag' && filterId > 0) {
        postData.tag_id = filterId
      } else {
        postData.cat_id = $paginationContainer.data('cat-id')
      }

      $.ajax({
        url: MyAjax.ajaxurl,
        type: 'POST',
        data: postData,
        success: function (response) {
          if (response.success) {
            $postContainer.html(response.data.post_html)
            $paginationContainer.html(response.data.pagination_html)

            $('.js-ajax-filter').removeClass('active')
            if (currentFilterId > 0) {
              $(
                `.js-ajax-filter[data-id="${currentFilterId}"][data-type="${currentFilterType}"]`
              ).addClass('active')
            }

            $('html, body').animate(
              {
                scrollTop: $postContainer.offset().top - 50
              },
              500
            )
          } else {
            console.error('AJAX Error:', response.data)
          }
        },
        error: function (xhr, status, error) {
          console.error('AJAX Request Failed:', status, error)
        },
        complete: function () {
          $postContainer.css('opacity', '1')
          $paginationContainer.css('pointer-events', 'auto')
        }
      })
    }

    $paginationContainer.on('click', 'a.page-numbers', function (e) {
      e.preventDefault()

      const maxPages = $paginationContainer.data('max-pages')

      let newPage
      const $this = $(this)
      const current = parseInt(
        $paginationContainer.find('.page-numbers.current').text()
      )

      if ($this.hasClass('next')) {
        newPage = current < maxPages ? current + 1 : maxPages
      } else if ($this.hasClass('prev')) {
        newPage = current > 1 ? current - 1 : 1
      } else {
        newPage = parseInt($this.text())
      }

      if (isNaN(newPage) || newPage < 1 || newPage > maxPages) {
        return
      }

      loadPosts(newPage)
    })

    $('.js-ajax-filter').on('click', function (e) {
      e.preventDefault()

      const $this = $(this)
      const clickedFilterId = $this.data('id')
      const clickedFilterType = $this.data('type')
      const defaultCatId = $paginationContainer.data('cat-id')

      if ($this.hasClass('active')) {
        currentFilterId = defaultCatId
        currentFilterType = 'cat'

        $('.js-ajax-filter').removeClass('active')
        loadPosts(1, defaultCatId, 'cat')
      } else {
        currentFilterId = clickedFilterId
        currentFilterType = clickedFilterType

        $('.js-ajax-filter').removeClass('active')
        $this.addClass('active')

        loadPosts(1, clickedFilterId, clickedFilterType)
      }
    })
  })
}
